var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg114Flag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.097,262.582l-101.479-89.955l100.67-84.508c0.046-0.039,0.093-0.078,0.139-0.118 c16.084-13.754,21.739-35.467,14.408-55.32c-7.33-19.851-25.741-32.678-46.902-32.678H79.999C35.887,0.003,0,35.891,0,80.002 v411.994c0,11.046,8.954,20,20,20s20-8.954,20-20V80.002c0-22.056,17.944-39.999,39.999-39.999h381.934 c6.288,0,8.654,4.571,9.381,6.536c0.723,1.958,1.889,6.941-2.83,11.02l-118.338,99.34c-4.454,3.739-7.061,9.233-7.139,15.049 c-0.079,5.815,2.378,11.377,6.731,15.235l118.828,105.332c4.661,4.132,3.452,9.091,2.717,11.031 c-0.737,1.94-3.122,6.453-9.351,6.453H119.998c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h341.933 c20.963,0,39.311-12.664,46.748-32.262C516.115,298.136,510.784,276.487,495.097,262.582z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg114Flag);
export default __webpack_public_path__ + "static/media/114-flag.dfd5837c67e0427ad5d199f63be7a71b.svg";
export { ForwardRef as ReactComponent };